var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrophy(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.99984 7.49967H3.74984C3.1973 7.49967 2.6674 7.28018 2.2767 6.88948C1.886 6.49878 1.6665 5.96888 1.6665 5.41634C1.6665 4.86381 1.886 4.3339 2.2767 3.9432C2.6674 3.5525 3.1973 3.33301 3.74984 3.33301H4.99984",
    stroke: "#EAB308",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 7.49967H16.25C16.8025 7.49967 17.3324 7.28018 17.7231 6.88948C18.1138 6.49878 18.3333 5.96888 18.3333 5.41634C18.3333 4.86381 18.1138 4.3339 17.7231 3.9432C17.3324 3.5525 16.8025 3.33301 16.25 3.33301H15",
    stroke: "#EAB308",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.3335 18.333H16.6668",
    stroke: "#EAB308",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.3335 12.2168V14.1668C8.3335 14.6251 7.94183 14.9835 7.52516 15.1751C6.54183 15.6251 5.8335 16.8668 5.8335 18.3335",
    stroke: "#EAB308",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6665 12.2168V14.1668C11.6665 14.6251 12.0582 14.9835 12.4748 15.1751C13.4582 15.6251 14.1665 16.8668 14.1665 18.3335",
    stroke: "#EAB308",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15 1.66699H5V7.50033C5 8.82641 5.52678 10.0982 6.46447 11.0359C7.40215 11.9735 8.67392 12.5003 10 12.5003C11.3261 12.5003 12.5979 11.9735 13.5355 11.0359C14.4732 10.0982 15 8.82641 15 7.50033V1.66699Z",
    stroke: "#EAB308",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrophy);
export default __webpack_public_path__ + "static/media/trophy.ad177a7894fe4e9361cb64a13d76a967.svg";
export { ForwardRef as ReactComponent };